import graphql__96ff9e08273f1568f762 from "./__generated__/ParticipativeModuleResultsFormFieldStacked_result.graphql.js";import { graphql, useFragment } from "react-relay";

import Chart from "./Chart";
import ParticipativeModuleResultsFormFieldContainer from "./ParticipativeModuleResultsFormFieldContainer";
import { stackedChartConfig } from "../../lib/charts/stackedChart";
import { useChartOptions } from "../../lib/charts/useChartColors";

const ParticipativeModuleResultsFormFieldStacked = props => {
  const result = useFragment(
    ParticipativeModuleResultsFormFieldStacked_result,
    props.result
  );

  const { allowDisplayingPatternFill, chartLabel: label, colors } = result;

  const chartOptions = useChartOptions(colors);

  const chartConfig = {
    ...stackedChartConfig(result, { label }),
    ...chartOptions
  };

  return (
    <ParticipativeModuleResultsFormFieldContainer {...props} result={result}>
      <Chart
        allowDisplayingPatternFill={allowDisplayingPatternFill}
        chartOptions={chartConfig}
      />
    </ParticipativeModuleResultsFormFieldContainer>
  );
};

const ParticipativeModuleResultsFormFieldStacked_result = graphql__96ff9e08273f1568f762;

export default ParticipativeModuleResultsFormFieldStacked;
